import Vue from 'vue';
import { isMobile } from 'utils/general';
import on from 'dom-event';
import debounce from 'lodash.debounce';

export default (el) =>
  new Vue({
    el,
    name: 'Full width video',
    data() {
      return {
        desktopUrl: null,
        mobileUrl: null,
        video: null,
        isPaused: true,
        isMuted: true,
        isMobile: isMobile(),
      };
    },
    mounted() {
      if (Boolean(el.dataset.videoDesktopUrl)) {
        this.desktopUrl = el.dataset.videoDesktopUrl;
      }
      if (Boolean(el.dataset.videoMobileUrl)) {
        this.mobileUrl = el.dataset.videoMobileUrl;
      }
      on(window, 'resize', debounce(this.onResize, 300));
    },
    watch: {
      iFrameSrc() {
        const interval = setInterval(() => {
          if (window.Vimeo) {
            this.video = new Vimeo.Player(this.$refs.iFrameEl);
            clearInterval(interval);
          }
        }, 100);
      },
    },
    computed: {
      iFrameSrc() {
        if (this.isMobile) {
          if (this.mobileUrl) {
            return this.mobileUrl;
          } else {
            return this.desktopUrl;
          }
        } else {
          if (this.desktopUrl) {
            return this.desktopUrl;
          } else {
            return this.mobileUrl;
          }
        }
      },
    },
    methods: {
      handlePauseClick() {
        this.isPaused ? this.video.play() : this.video.pause();
        this.isPaused = !this.isPaused;
      },
      handleSoundClick() {
        this.isMuted = !this.isMuted;
        this.video.setMuted(this.isMuted);
      },
      onResize() {
        this.isMobile = isMobile();
      },
    },
  });
